import {Component, OnInit, OnDestroy ,ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {NotifierService} from 'angular-notifier';
import {Formatters} from 'angular-slickgrid';
import {MessageService} from '../message.service';
import {CustomInputEditor} from '../custom-inputEditor';
import {RestApiService} from '../rest-api.service';
import {NgbModal , NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';
import { borderTopRightRadius } from 'html2canvas/dist/types/css/property-descriptors/border-radius';


@Component({
  selector: 'app-impact',
  templateUrl: './impact.component.html',
  styleUrls: ['./impact.component.css']
})
export class ImpactComponent implements OnInit, OnDestroy {

  displayed = true;
  impactName: string;
  desc: string;
  seq: string;
  clientId: number;

  add = false;
  del = false;
  edit = false;
  view = false;

  displayData: any;

  isError = false;
  errorMessage: string;
  respObject: any;
  totalData: number;

  tickets = [];
  ticketSelected: number;
  type: string;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private notifier: NotifierService;
  private userAuth: Subscription;
  private baseFlag: any;
  offset: number;
  dataLoaded: boolean;
  showSearch = true;
  isLoading = false;
  searchData: FormControl = new FormControl();
  impactSelected: any;
  impacts: any;
  des: string;
  showExportBtn = true;
  dataExcel = [];
  @ViewChild('scarch_content') private scarch_content;
  private searchModalReference: NgbModalRef;


  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      // console.log(item);
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {
            if (confirm('Are you sure?')) {
              item.user_id = this.messageService.getUserId();
              this._rest.updateBusinessImpact(item).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // console.log('data--Done');
                  this.notifier.notify('success', 'Updated successfully');
                } else {
                  // console.log('data--Not---Done');
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
              });
            }
          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              // console.log(JSON.stringify(item));
              this._rest.deleteBusinessImpact({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // this.totalData = this.totalData - 1;
                  // this.messageService.setTotalData(this.totalData);
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
              });
            }
          }
          break;
      }
    });
    // this.messageService.getUserAuth().subscribe(details => {
    //   console.log(JSON.stringify(details));
    //   if (details.length > 0) {
    //     this.add = details[0].addFlag;
    //     this.del = details[0].deleteFlag;
    //     this.view = details[0].viewFlag;
    //     this.edit = details[0].editFlag;
    //   } else {
    //     this.add = true;
    //     this.del = true;
    //     this.view = true;
    //     this.edit = true;
    //   }
    // });

  }


  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Maintain BusinessImpact',
      openModalButton: 'Add BusinessImpact',
      searchModalButton: 'Search',
      breadcrumb: 'BusinessImpact',
      folderName: 'All BusinessImpact',
      tabName: 'BusinessImpact',
      exportBtn: 'Export to excel'

    };
    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'name', name: 'Impact Name', field: 'name', sortable: true, filterable: true,cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'person', name: 'Description', field: 'des', sortable: true, filterable: true,cssClass: 'highlight', editor: {
          model: CustomInputEditor,
        }
      },
      {
        id: 'ttype', name: 'TicketType ', field: 'ticket_type', sortable: true, filterable: true
      },
      {
        id: 'number', name: 'Sequence', field: 'seq', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }
  }

  onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.isError = false;
            this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
            this.tickets = this.respObject.details;
            this.ticketSelected = 0;
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', JSON.stringify(err));
        });
    this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }


  exportToExcel() {
    // console.log("okkk" +this.clientId);
    this._rest.getAllBusinessImpact(this.clientId).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
            this.dataExcel = this.respObject.details;
            // console.log('true' + JSON.stringify(this.dataExcel));
            this.messageService.exportAsExcelFile(this.dataExcel);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
}

  openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.impactName = '';
      this.desc = '';
      this.seq = '';
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {

      });
    }
  }

  searchModal()   {

      this.impactSelected = '';
            this.searchModalReference = this.modalService.open(this.scarch_content);
            this.searchModalReference.result.then((result) => {
            }, (reason) => {

            });
    
  }

  search() {
    this._rest.searchAllBusinessImpact(this.impactSelected, this.clientId).subscribe((res1) => {
      this.respObject = res1;
      this.isLoading = false;
      if (this.respObject.success) {
        this.impacts = this.respObject.details;
        this.messageService.setTotalData(this.impacts.length);
        this.messageService.setGridData(this.impacts);
        this.searchModalReference.close();

      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.isLoading = false;
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }


  save() {
    const data = {
      clientId: this.clientId, name: this.impactName, des: this.desc,
      seq: this.seq, createdBy: this.messageService.getUserId(), ticket_type: this.ticketSelected,
    };
    if (!this.messageService.isBlankField(data)) {
      this._rest.insertBusinessImpact(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
          this.isError = false;
          const id = this.respObject.id;
          this.messageService.setRow({
            id: id,
            name: this.impactName,
            des: this.desc,
            seq: this.seq,
            ticket_type: this.type
          });
          if (this.totalData <= this.pageSize * this.page_no) {
              this.offset = id;
              this.nextOffset = 0;
          } else {
              this.nextOffset = this.offset;
          }
          this.impactName = '';
          this.desc = '';
          this.seq = '';
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }



  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded=false;
    this._rest.getBusinessImpact(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }


  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  onTicketChange(selectedIndex: any) {
    this.type = this.tickets[selectedIndex].name;
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }
}
